import { useAppSelector } from '@/Redux/store';

export function useAuth() {
  const { user, status, error } = useAppSelector((s) => s.auth);
  return {
    user,
    error,
    isLoading: status === 'loading',
    isAuthenticated: status === 'authenticated' && !!user,
  };
}
